import { Button, Col, Row } from "antd";

import { APP_NAME } from 'configs/AppConfig';
import { ArrowLeftOutlined } from '@ant-design/icons';
import Flex from 'components/shared-components/Flex';
import { Link } from 'react-router-dom';
import React from 'react'
import SvgNotFound from 'components/Svgs/404';
import { useSelector } from 'react-redux';

const logo = <img src="/img/icons/ArborSlogan.svg" alt="" width={30} height={30} />

const ErrorOne = () => {
	const theme = useSelector(state => state.theme.currentTheme)
	return (
		<div style={{ height: "100vh" }}>
			<div className={`h-100 ${theme === 'light' ? 'bg-white' : ''}`}>
				<div className="container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1">
					<div className='d-flex'>
						<span className="d-flex align-items-center" style={{ color: "#662d91" }}>{logo}</span>
					</div>
					<div className="container">
						<Row align="middle">
							<Col xs={24} sm={24} md={8}>
								<h1 className="font-weight-bold mb-4 display-4">Página não encontrada</h1>
								<p className="font-size-md mb-4">Percebemos que você se perdeu, não se preocupe, nós o ajudaremos a encontrar o caminho correto.</p>
								<Link to='/app'>
									<Button type="primary" icon={<ArrowLeftOutlined />}>Voltar</Button>
								</Link>
							</Col>
							<Col xs={24} sm={24} md={{ span: 14, offset: 2 }}>
								<SvgNotFound />
							</Col>
						</Row>
					</div>
					<Flex mobileFlex={false} justifyContent="between">
						<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span></span>
					</Flex>
				</div>
			</div>
		</div>
	)
}

export default ErrorOne
